module.exports = __webpack_public_path__ + "img/Content2.feba44bc.png";